<button type="button" class="btn btn-secondary mr-2" (click)="onClick()">
    <i class="fa fa-rotate-right" style="font-size: 20px;"></i> Refresh
  </button>
  